import { flFetch as fetch, validateStatus } from "./fetch";

export const fetchCurrentNotices = () => {
  return fetch(`${process.env.REACT_APP_API_URL}/info/notices/current`, {
    method: "GET"
  }).then(validateStatus);
};
